import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { SelectInput, useRecordContext, useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import useNotify from "../unit/useNotify";
import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import { useForm, FormProvider } from "react-hook-form";
const CouponCodeLink = ({ ...props }) => {
  const record = useRecordContext();
  // const id = record?.id;
  const [couponcodeToken, setCouponcodeToken] = React.useState(
    record?.sCode || ""
  );
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "general/couponcodelink";
    sendRequest(reqUrl, { id: "random" }).then((response) => {
      if (response) {
        setCouponcodeToken(response?.random_code);
        props?.onChange(response?.random_code);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(couponcodeToken);
    success("Link copied to clipboard");
  };

  return (
    <Box>
      <TextField
        id="sCode"
        label="Coupon Code"
        variant="outlined"
        value={couponcodeToken}
        required={true}
        onChange={(e) => {
          setCouponcodeToken(e.target.value);
          props?.onChange(e.target.value);
        }}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        inputProps={{
          maxLength: 6,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate Code"}
                onClick={handleClick}
                edge="end"
                disabled={couponcodeToken ? true : false}
              >
                <RefreshIcon color={couponcodeToken ? "disabled" : "primary"} />
              </IconButton>{" "}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
const CouponCodeAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [couponCode, setCouponCode] = React.useState("");

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };
  const handleChangeCouponCode = (value: string) => {
    setCouponCode(value);
  };

  return (
    <>
      <Button
        id="btn-list-add-couponcode"
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "150px",
          minWidth: "150px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Coupon Code
      </Button>
      <FormProvider {...methods}>
        <Dialog
          id="dialog-couponcode-add"
          className="couponcodes_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());

              formJson.sCode = couponCode;
              if (formJson.sCode == "") {
                errorNotify("Coupon code is required");
                return;
              }
              if (formJson.sCode.length !== 6) {
                errorNotify("Coupon code must be 6 characters");
                return;
              }
              if (formJson.sType == "") {
                errorNotify("Type is required");
                return;
              }

              if (formJson.sType === "amount") {
              } else if (formJson.sType === "discount") {
                if (formJson.fValue > 0 && formJson.fValue <= 100) {
                } else {
                  errorNotify("Invalid discount value");
                  return;
                }
              }

              if (formJson.dtStart <= new Date()) {
                errorNotify("Invalid start date");
                return;
              }
              if (formJson.dtEnd <= formJson.dtStart) {
                errorNotify("Invalid date range");
                return;
              }

              const reqUrl = `couponcodes/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });

              if (response && response.code == "200") {
                successNotify(
                  "Data saved successfully! Please add products to enable it!"
                );
                handleClose();
              } else {
                errorNotify(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              mb: 2,
              borderBottom: "1px solid #e5e5e5",
              color: "#465384",
              textTransform: "uppercase",
            }}
          >
            Coupon Code
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                height: "50vh",
                maxHeight: "50vh",
              }}
            >
              {/* <HmTextInput source="sCode" label="Coupon Code" required={true} /> */}
              <CouponCodeLink
                couponCode={couponCode}
                onChange={handleChangeCouponCode}
              />
              {/* Reduction from Original */}
              <HmTextInput
                source="fValue"
                // label="Reduction from Original"
                label="Reduction"
                required={true}
                type="number"
                sx={{ width: "79%" }}
              />
              <SelectInput
                source="sType"
                label="Type"
                variant="outlined"
                choices={[
                  { id: "amount", name: "$" },
                  {
                    id: "discount",
                    name: "%",
                  },
                ]}
                required={true}
                helperText={false}
                sx={{ width: "20%", marginLeft: "1%" }}
              />
              {/* Activation Date */}
              <HmTextInput
                source="dtStart"
                label="Activation Date"
                required={true}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
              <HmTextInput
                source="dtEnd"
                label="Expiration Date"
                required={true}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <CustomButtonCancel onClick={handleClose} />
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default CouponCodeAdd;
